import {RepositoryFactory} from '../../api/RepositoryFactory';

export default {
    actions: {
        GET_QUIZZES: async (context, payload) => {
            await RepositoryFactory.get('quizzes').get(payload).then((res) => {
                console.log(res.data.quizzes)
                context.commit('SET_QUIZZES', res.data.quizzes)
            });
        }
    },

    mutations: {
        SET_QUIZZES: (state, payload) => {
            state.quizzes = payload;
        }
    },

    state: {
        quizzes: []
    },

    getters: {
        QUIZZES: state => {
            return state.quizzes;
        }
    }
}